import { connect } from 'react-redux'
import OauthCallback from './oauth-callback'
import { withRouter } from 'react-router-dom'
import qs from 'qs'
import { twitterCallback, o365Callback } from 'pobble-components/dist/oauth'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { finishSignin } from '../helpers'

const callbacksMap = {
  twitter: twitterCallback,
  o365: o365Callback
}

const mapDispatchToProps = (dispatch, { location, history, match }) => ({
  onMount: () => {
    const PROVIDER = match.params.provider
    const PARAMS = qs.parse(location.search, { ignoreQueryPrefix: true })
    callbacksMap[PROVIDER](PARAMS, 'auth')
      .then(res => finishSignin(res, location, history))
      .catch(e => {
        e !== 'CANCEL' && errorHandler(e)
        history.push('/')
      })
  }
})

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(OauthCallback)
)
